var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserManagementIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2599 7.13333C9.99325 6.94667 9.77992 6.8 9.61325 6.68C10.0533 6.25333 10.3333 5.66 10.3333 5V4.33333C10.3333 3.04667 9.28659 2 7.99992 2C6.71325 2 5.66659 3.04667 5.66659 4.33333V5C5.66659 5.66 5.94659 6.25333 6.38659 6.68C6.21325 6.8 6.00659 6.94667 5.73992 7.13333C4.80659 7.78667 4.33325 8.58667 4.33325 9.51333V14H11.6666V9.51333C11.6666 8.58667 11.1933 7.78667 10.2599 7.13333ZM6.66659 4.33333C6.66659 3.6 7.26659 3 7.99992 3C8.73325 3 9.33325 3.6 9.33325 4.33333V5C9.33325 5.73333 8.73325 6.33333 7.99992 6.33333C7.26659 6.33333 6.66659 5.73333 6.66659 5V4.33333ZM10.6666 13H5.33325V9.51333C5.33325 9.14 5.43325 8.56667 6.31325 7.95333C6.65992 7.71333 6.91992 7.52667 7.11325 7.39333L7.37992 8.19333L7.05325 10.46L8.01992 12.4L8.99325 10.46L8.66659 8.19333L8.92659 7.42C9.11325 7.55333 9.35992 7.72667 9.68659 7.95333C10.5599 8.56667 10.6666 9.13333 10.6666 9.51333V13Z",
    fill: "#7D7D7D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserManagementIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/User_Management_Icon.72f8ddbc23c4865eef2bac14f710f662.svg";